export const BrandMark = ({ className = '' }) => (
  <span className={`brand-mark ${className}`.trim()} aria-hidden="true">
    <svg viewBox="0 0 32 32" fill="currentColor">
      <path d="M16 3.5c-1.2 3.8-4.8 6.4-8.7 6.4-.3 0-.6 0-.9-.1 2.8 2.1 6.3 3.4 10.1 3.4 3.8 0 7.3-1.3 10.1-3.4-.3 0-.6.1-.9.1-3.9 0-7.5-2.6-8.7-6.4z" />
      <path d="M16 28.5c1.2-3.8 4.8-6.4 8.7-6.4.3 0 .6 0 .9.1-2.8-2.1-6.3-3.4-10.1-3.4-3.8 0-7.3 1.3-10.1 3.4.3 0 .6-.1.9-.1 3.9 0 7.5 2.6 8.7 6.4z" />
    </svg>
  </span>
);
